import { Dispatch } from 'redux'
import { ActionType, SalesAction } from './actionTypes'
import { Budget, Customer, CustomerType, HoardOrder, SaleOrder } from './types'

export const updateSales = (sales: SaleOrder[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.UPDATE_SALES,
            payload: sales
        })
    }
}

export const clearSales = () => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.SET_SALES,
            payload: []
        })
    }
}

export const removeSales = (ids: string[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.REMOVE_SALES,
            payload: ids
        })
    }
}

export const updateBudgets = (budgets: Budget[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.UPDATE_BUDGETS,
            payload: budgets
        })
    }
}

export const removeBudgets = (ids: string[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.REMOVE_BUDGETS,
            payload: ids
        })
    }
}

export const clearHoards = () => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.SET_HOARDS,
            payload: []
        })
    }
}

export const updateHoards = (hoards: HoardOrder[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.UPDATE_HOARDS,
            payload: hoards
        })
    }
}

export const removeHoards = (ids: string[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.REMOVE_HOARDS,
            payload: ids
        })
    }
}

export const clearCustomers = () => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.SET_CUSTOMERS,
            payload: []
        })
    }
}

export const updateCustomers = (customers: Customer[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.UPDATE_CUSTOMERS,
            payload: customers
        })
    }
}

export const removeCustomers = (ids: string[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.REMOVE_CUSTOMERS,
            payload: ids
        })
    }
}

export const clearCustomerTypes = () => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.SET_CUSTOMER_TYPES,
            payload: []
        })
    }
}

export const updateCustomerTypes = (customerTypes: CustomerType[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.UPDATE_CUSTOMER_TYPES,
            payload: customerTypes
        })
    }
}

export const removeCustomerTypes = (ids: string[]) => {
    return (dispatch: Dispatch<SalesAction>) => {
        dispatch({
            type: ActionType.REMOVE_CUSTOMER_TYPES,
            payload: ids
        })
    }
}
